import React from "react";
import { Link } from "react-router-dom";
import Slider from "../components/Slider";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>
          Home | Orient Elevators Pvt. Ltd. | Leading Elevator & Lift Solutions
          in India
        </title>

        <meta
          name="description"
          content="Welcome to Orient Elevators Pvt. Ltd., a trusted leader in elevator and lift solutions in India. We specialize in passenger elevators, goods lifts, installation, maintenance, and modernization services."
        />

        <meta
          name="keywords"
          content="Orient Elevators, passenger elevators, goods lifts, elevator installation, lift maintenance, commercial elevators, home lifts, elevator modernization"
        />

        <link rel="canonical" href="https://example.com/your-page" />
      </Helmet>

      <main className="main">
        <Slider />

        {/* Feature */}

        <div className="feature-area ft-bg1" id="Feature">
          <div className="container">
            <div className="feature-wrapper">
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div
                    className="feature-item wow fadeInUp"
                    data-wow-delay=".25s"
                  >
                    <span className="count">01</span>
                    <div className="feature-icon">
                      <i className="icon-technician"></i>
                    </div>
                    <h4 className="feature-title">Innovative Technology</h4>
                    <p>Smart, efficient, and eco-friendly elevator systems.</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div
                    className="feature-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <span className="count">02</span>
                    <div className="feature-icon">
                      <i className="icon-satisfaction"></i>
                    </div>
                    <h4 className="feature-title">Unmatched Safety</h4>
                    <p>Compliant with global safety standards.</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div
                    className="feature-item wow fadeInUp"
                    data-wow-delay=".25s"
                  >
                    <span className="count">03</span>
                    <div className="feature-icon">
                      <i className="icon-shield"></i>
                    </div>
                    <h4 className="feature-title">End-to-End Service</h4>
                    <p>From design to maintenance, we handle it all.</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div
                    className="feature-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <span className="count">04</span>
                    <div className="feature-icon">
                      <i className="icon-easy-installation"></i>
                    </div>
                    <h4 className="feature-title">Trusted Expertise</h4>
                    <p>15+ years of engineering excellence.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*End Feature */}

        {/*About Us */}

        <div className="about-area py-120">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div
                  className="about-left wow fadeInLeft"
                  data-wow-delay=".25s"
                >
                  <div className="about-img">
                    <img src="assets/img/about/01.jpg" />
                  </div>
                  <div className="about-experience">
                    {/* <div className="about-experience-icon">
                      <i className="icon-plug"></i>
                    </div> */}
                    <b className="text-start">
                      15+ Years Of <br /> Quality Service
                    </b>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="about-right wow fadeInRight"
                  data-wow-delay=".25s"
                >
                  <div className="site-heading mb-3">
                    <span className="site-title-tagline">
                      <i className="far fa-lightbulb-on"></i> About Us
                    </span>
                    <h2 className="site-title">
                      Orient <span>Elevators</span>
                    </h2>
                  </div>
                  <p className="about-text text-justify">
                    Orient Elevators Pvt. Ltd. is one of India’s leading
                    providers of elevator and escalator solutions, dedicated to
                    redefining vertical transportation through innovation,
                    safety, and reliability. With a strong foundation built on
                    engineering excellence and customer trust, Orient Elevators
                    has become a preferred partner for developers, architects,
                    and facility managers across the country.
                  </p>
                  <p className="about-text text-justify">
                    {" "}
                    Founded with a vision to deliver world-class mobility
                    solutions, the company specializes in the design,
                    manufacturing, installation, modernization, and maintenance
                    of elevators and escalators. From residential complexes and
                    commercial towers to hospitals, hotels, and industrial
                    facilities, Orient Elevators provides customized solutions
                    that meet the diverse needs of modern infrastructure.
                  </p>

                  <a href="#" className="theme-btn mt-4 ">
                    <Link to="/about" className="text-white">
                      {" "}
                      Read More <i className="fas fa-arrow-right-long"></i>
                    </Link>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*End About Us */}
        {/* Services */}
        <div className="feature-area ft-bg py-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mx-auto">
                <div className="site-heading text-center">
                  {/* <span class="site-title-tagline">
                    <i class="far fa-lightbulb-on"></i> Our Feature
                  </span> */}
                  <h2 className="site-title text-white">
                    OUR <span>SERVICES</span>
                  </h2>
                </div>
              </div>
            </div>
            <div className="feature-wrapper">
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div
                    className="text-center service-item wow fadeInUp"
                    data-wow-delay=".25s"
                  >
                    <div className="service-img">
                      <img src="assets/img/project/1.jpg" alt="img" />
                      <div class="service-icon">
                        <i class="icon-electric"></i>
                      </div>
                    </div>
                    <div className="service-content">
                      <h3 className="service-title">
                        <a href="#">Passenger Elevators</a>
                      </h3>
                      <p className="service-text">
                        Orient Elevators offers state-of-the-art Passenger
                        Elevators designed for comfort, safety, and efficiency.
                        Built with advanced technology and precision engineering
                      </p>

                      <ul className="btn-call">
                        <li>
                          <div className="btn-box">
                            <a href="tel:+919918001880" class="btn btn-primary">
                              {" "}
                              <i className="fa fa-phone"></i> Call Now
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="btn-box">
                            <a
                              href="https://wa.me/+919918001880"
                              className="btn btn-success thm-btn"
                            >
                              <i className="fa fa-whatsapp"></i> Whatsapp
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div
                    className="text-center service-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <div className="service-img">
                      <img src="assets/img/project/2.jpg" alt="img" />
                      <div className="service-icon">
                        <i className="icon-electric"></i>
                      </div>
                    </div>
                    <div className="service-content">
                      <h3 className="service-title">
                        <a href="#">Hospital Elevators</a>
                      </h3>
                      <p className="service-text">
                        Orient Elevators provides specially designed Hospital
                        Elevators that ensure safe, smooth, and hygienic
                        transportation within healthcare environments.
                      </p>
                      <ul className="btn-call">
                        <li>
                          <div className="btn-box">
                            <a href="tel:+919918001880" class="btn btn-primary">
                              {" "}
                              <i className="fa fa-phone"></i> Call Now
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="btn-box">
                            <a
                              href="https://wa.me/+919918001880"
                              className="btn btn-success thm-btn"
                            >
                              <i className="fa fa-whatsapp"></i> Whatsapp
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div
                    className="text-center service-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <div className="service-img">
                      <img src="assets/img/project/3.jpg" alt="img" />
                      <div className="service-icon">
                        <i className="icon-electric"></i>
                      </div>
                    </div>
                    <div className="service-content">
                      <h3 className="service-title">
                        <a href="#">Bungalow Elevators</a>
                      </h3>
                      <p className="service-text">
                        Orient Elevators offers elegant and efficient Bungalow
                        Elevators designed to enhance comfort, convenience, and
                        luxury in private residences.
                      </p>
                      <ul className="btn-call">
                        <li>
                          <div className="btn-box">
                            <a href="tel:+919918001880" class="btn btn-primary">
                              {" "}
                              <i className="fa fa-phone"></i> Call Now
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="btn-box">
                            <a
                              href="https://wa.me/+919918001880"
                              className="btn btn-success thm-btn"
                            >
                              <i className="fa fa-whatsapp"></i> Whatsapp
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div
                    className="text-center service-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <div className="service-img">
                      <img src="assets/img/project/4.jpg" alt="img" />
                      <div className="service-icon">
                        <i className="icon-electric"></i>
                      </div>
                    </div>
                    <div className="service-content">
                      <h3 className="service-title">
                        <a href="#">Capsule Elevators</a>
                      </h3>
                      <p className="service-text">
                        Orient Elevators presents premium Capsule Elevators that
                        combine advanced engineering with stunning aesthetics,
                        creating a perfect blend of functionality.
                      </p>
                      <ul className="btn-call">
                        <li>
                          <div className="btn-box">
                            <a href="tel:+919918001880" class="btn btn-primary">
                              {" "}
                              <i className="fa fa-phone"></i> Call Now
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="btn-box">
                            <a
                              href="https://wa.me/+919918001880"
                              className="btn btn-success thm-btn"
                            >
                              <i className="fa fa-whatsapp"></i> Whatsapp
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div
                    className="text-center service-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <div className="service-img">
                      <img src="assets/img/project/5.jpg" alt="img" />
                      <div className="service-icon">
                        <i class="icon-electric"></i>
                      </div>
                    </div>
                    <div className="service-content">
                      <h3 class="service-title">
                        <a href="#">Goods Elevators</a>
                      </h3>
                      <p className="service-text">
                        Orient Elevators offers robust and high-performance
                        Goods Elevators designed to handle heavy loads with
                        safety, strength, and efficiency.
                      </p>
                      <ul className="btn-call">
                        <li>
                          <div className="btn-box">
                            <a href="tel:+919918001880" class="btn btn-primary">
                              {" "}
                              <i className="fa fa-phone"></i> Call Now
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="btn-box">
                            <a
                              href="https://wa.me/+919918001880"
                              className="btn btn-success thm-btn"
                            >
                              <i className="fa fa-whatsapp"></i> Whatsapp
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div
                    className="text-center service-item wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <div className="service-img">
                      <img src="assets/img/project/6.jpg" alt="img" />
                      <div className="service-icon">
                        <i className="icon-electric"></i>
                      </div>
                    </div>
                    <div className="service-content">
                      <h3 className="service-title">
                        <a href="#">Service Elevators</a>
                      </h3>
                      <p className="service-text">
                        Orient Elevators provides reliable and efficient Service
                        Elevators specially designed for the smooth
                        transportation of goods, supplies, and staff in
                        commercial
                      </p>
                      <ul className="btn-call">
                        <li>
                          <div className="btn-box">
                            <a href="tel:+919918001880" class="btn btn-primary">
                              {" "}
                              <i className="fa fa-phone"></i> Call Now
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="btn-box">
                            <a
                              href="https://wa.me/+919918001880"
                              className="btn btn-success thm-btn"
                            >
                              <i className="fa fa-whatsapp"></i> Whatsapp
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*End Services */}
        {/*End SCOPE OF WORK */}
        <div className="service-area2 bg py-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mx-auto">
                <div className="site-heading text-center">
                  <h2 className="site-title">
                    SCOPE OF <span>WORK</span>
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <i className="icon-electric"></i>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Consultation & Design</a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <i className="icon-light-bulb-1"></i>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Manufacturing & Supply</a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <i className="icon-cctv-camera"></i>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Installation </a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <img src="assets/img/Substations.png" class="ic" />
                    {/* <i className="icon-light-bulb-1"></i> */}
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Modernization </a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <img src="assets/img/DGSets.png" class="ic" />
                    {/* <i className="icon-cabinet"></i> */}
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Annual Service</a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <img src="assets/img/Earthing.png" class="ic" />
                    {/* <i className="icon-shield-1"></i> */}
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Safety & Compliance</a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <i className="icon-shield-1"></i>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Custom Solutions</a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-icon">
                    <img src="assets/img/FireAlarm.png" class="ic" />
                    {/* <i className="icon-fan"></i> */}
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Safety & Compliance </a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*End SCOPE OF WORK */}
      </main>
    </div>
  );
};
export default Home;
